import * as React from 'react'
import classes from './style.module.css'

interface SectionWrapperProps {
  bgColor?: string
  children: React.ReactNode
}

export default function SectionWrapper({bgColor, children}: SectionWrapperProps) {
  return (
    <div className={classes.container} style={{background: bgColor}}>
      <div className={classes.subContainer}>{children}</div>
    </div>
  )
}
